import * as b from "react";
import { g as B, c as z } from "./generateUtilityClass-DMFG5-Cu.mjs";
import { m as d } from "./memoTheme-BzXKG_-k.mjs";
import { c as u } from "./createSimplePaletteValueFilter-B7--0ryQ.mjs";
import { g as R } from "./generateUtilityClasses-CWIIr9E_.mjs";
import { j as I } from "./jsx-runtime-3tyXYecC.mjs";
import { s as C, u as S, c as $ } from "./DefaultPropsProvider-CFfEbxdP.mjs";
import { B as x } from "./ButtonBase-BIvHZGlt.mjs";
import { c as r, b as g } from "./tss-DN0acMKN.mjs";
function O(o) {
  return B("MuiIconButton", o);
}
const j = R("MuiIconButton", ["root", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "edgeStart", "edgeEnd", "sizeSmall", "sizeMedium", "sizeLarge"]), M = (o) => {
  const {
    classes: t,
    disabled: e,
    color: a,
    edge: s,
    size: n
  } = o, i = {
    root: ["root", e && "disabled", a !== "default" && `color${r(a)}`, s && `edge${r(s)}`, `size${r(n)}`]
  };
  return $(i, O, t);
}, k = C(x, {
  name: "MuiIconButton",
  slot: "Root",
  overridesResolver: (o, t) => {
    const {
      ownerState: e
    } = o;
    return [t.root, e.color !== "default" && t[`color${r(e.color)}`], e.edge && t[`edge${r(e.edge)}`], t[`size${r(e.size)}`]];
  }
})(d(({
  theme: o
}) => ({
  textAlign: "center",
  flex: "0 0 auto",
  fontSize: o.typography.pxToRem(24),
  padding: 8,
  borderRadius: "50%",
  color: (o.vars || o).palette.action.active,
  transition: o.transitions.create("background-color", {
    duration: o.transitions.duration.shortest
  }),
  variants: [{
    props: (t) => !t.disableRipple,
    style: {
      "--IconButton-hoverBg": o.vars ? `rgba(${o.vars.palette.action.activeChannel} / ${o.vars.palette.action.hoverOpacity})` : g(o.palette.action.active, o.palette.action.hoverOpacity),
      "&:hover": {
        backgroundColor: "var(--IconButton-hoverBg)",
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: "transparent"
        }
      }
    }
  }, {
    props: {
      edge: "start"
    },
    style: {
      marginLeft: -12
    }
  }, {
    props: {
      edge: "start",
      size: "small"
    },
    style: {
      marginLeft: -3
    }
  }, {
    props: {
      edge: "end"
    },
    style: {
      marginRight: -12
    }
  }, {
    props: {
      edge: "end",
      size: "small"
    },
    style: {
      marginRight: -3
    }
  }]
})), d(({
  theme: o
}) => ({
  variants: [{
    props: {
      color: "inherit"
    },
    style: {
      color: "inherit"
    }
  }, ...Object.entries(o.palette).filter(u()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      color: (o.vars || o).palette[t].main
    }
  })), ...Object.entries(o.palette).filter(u()).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      "--IconButton-hoverBg": o.vars ? `rgba(${(o.vars || o).palette[t].mainChannel} / ${o.vars.palette.action.hoverOpacity})` : g((o.vars || o).palette[t].main, o.palette.action.hoverOpacity)
    }
  })), {
    props: {
      size: "small"
    },
    style: {
      padding: 5,
      fontSize: o.typography.pxToRem(18)
    }
  }, {
    props: {
      size: "large"
    },
    style: {
      padding: 12,
      fontSize: o.typography.pxToRem(28)
    }
  }],
  [`&.${j.disabled}`]: {
    backgroundColor: "transparent",
    color: (o.vars || o).palette.action.disabled
  }
}))), N = /* @__PURE__ */ b.forwardRef(function(t, e) {
  const a = S({
    props: t,
    name: "MuiIconButton"
  }), {
    edge: s = !1,
    children: n,
    className: i,
    color: f = "default",
    disabled: l = !1,
    disableFocusRipple: c = !1,
    size: m = "medium",
    ...v
  } = a, p = {
    ...a,
    edge: s,
    color: f,
    disabled: l,
    disableFocusRipple: c,
    size: m
  }, y = M(p);
  return /* @__PURE__ */ I.jsx(k, {
    className: z(y.root, i),
    centerRipple: !0,
    focusRipple: !c,
    disabled: l,
    ref: e,
    ...v,
    ownerState: p,
    children: n
  });
});
export {
  N as I
};
//# sourceMappingURL=IconButton-BIUHNiXo.mjs.map
